// import React from "react";
// import "./CourseSection.css";
// import { Link } from "react-router-dom";

// const allCourses = [
//   { name: "Data Structures and Algorithms", image: "/dsa_main.png", year: "2nd Year", path: "/subject-DSAModules" },
//   { name: "Discrete Mathematics", image: "/dm_main.png", year: "2nd Year", path: "/subject-DMModules" },
//   { name: "DSD", image: "/dsd_main.png", year: "2nd Year", path: "/subject-DSDModules" },
//   { name: "Calculus", image: "/cal_main.png", year: "1st Year", path: "/subject-CalculusModules" },
//   { name: "Compiler Design", image: "/compiler_main.png", year: "3rd Year", path: "/subject-CDModules" },
//   { name: "Artificial Intelligence", image: "/ai_main.png", year: "3rd Year", path: "/subject-AIModules" },
//   { name: "OOPS", image: "/OOP_main.png", year: "1st Year", path: "/subject-OOPSModules" },
//   { name: "Differential Equations", image: "/Screenshot 2025-02-18 123226.png", year: "1st Year", path: "/subject-DEModules" },
//   { name: "Chemistry", image: "/chemistry_main.png", year: "1st Year", path: "/subject-ChemistryModules" },
//   { name: "BEEE", image: "/beee_main.png", year: "1st Year", path: "/subject-BEEEModules" },
//   { name: "DAA", image: "/DAA2.png", year: "2nd Year", path: "/subject-DAAModules" },
//   { name: "CAO", image: "/CAO1.jpg", year: "2nd Year", path: "/subject-CAOmodules" },
//   { name: "TOC", image: "/TOC3.png", year: "2nd Year", path: "/subject-TOCModules" },
//   { name: "MPMC", image: "/Mpmc.jpg", year: "2nd Year", path: "/subject-MPMCModules" },
//   { name: "Complex Variables and Linear Algebra", image: "/cvla.jpg", year: "2nd Year", path: "/subject-CVLAModules" },

//   { name: "Computer Networks", image: "/cn.jpg", year: "2nd Year", path: "/subject-CNModules" },
//   { name: "DBMS", image: "/dbms.jpg", year: "2nd Year", path: "/subject-DBMSModules" },
//   { name: "Operating Systems", image: "/os.jpg", year: "2nd Year", path: "/subject-OSModules" },


// ];

// const CourseCard = ({ name, image, year, path }) => (
//   <li>
//     <div className="course-card">
//       <figure className="card-banner img-holder" style={{ "--width": 370, "--height": 220 }}>
//         <img src={image} width="370" height="220" loading="lazy" alt={name} className="img-cover" />
//       </figure>
//       <div className="card-content">
//         <span className="badge">{year}</span>
//         <h3 className="h3">{name}</h3>
//         <Link to={path} className="btn has-before">
//           <span className="span">Start Learning</span>
//         </Link>
//       </div>
//     </div>
//   </li>
// );

// const CoursesPage = () => {
//   return (
//     <>
//       <section className="section course" id="courses" aria-label="course" style={{paddingTop: '120px'}}>
//         <div className="container">
//           <p className="section-subtitle">Choose Your Subject!</p>
//           <h2 className="h2 section-title">Pick a Subject and get started!</h2>
//           <ul className="grid-list">
//             {allCourses.map((course, index) => (
//               <CourseCard key={index} {...course} />
//             ))}
//           </ul>
//         </div>
//       </section>
//     </>
//   );
// };

// export default CoursesPage;
import React, { useState } from "react";
import "./CourseSection.css";
import { Link } from "react-router-dom";

const allCourses = [
  { name: "Differential Equations", image: "/Screenshot 2025-02-18 123226.png", year: "1st Year", path: "/subject-DEModules" },
  { name: "Software Engineering", image: "/se_main.png", year: "3rd Year", path: "/subject-SEModules" },
  { name: "Cryptography And Network Security", image: "/cns_main.png", year: "3rd Year", path: "/subject-CNSModules" },
  { name: "Embedded Systems", image: "/es_main.png", year: "3rd Year", path: "/subject-ESModules" },
  { name: "Computer Networks", image: "/CN_main.png", year: "3rd Year", path: "/subject-CNModules" },
  { name: "Operating Systems", image: "/os_main.png", year: "3rd Year", path: "/subject-OSModules" },
  { name: "Database Systems", image: "/dbms_main.png", year: "3rd Year", path: "/subject-DBMSModules" },
  { name: "Complex Variables and Linear Algebra", image: "/cvla_main.png", year: "2nd Year", path: "/subject-CVLAModules" },
  { name: "Data Structures and Algorithms", image: "/dsa_main.png", year: "2nd Year", path: "/subject-DSAModules" },
  { name: "Discrete Mathematics", image: "/dm_main.png", year: "2nd Year", path: "/subject-DMModules" },
  { name: "DSD", image: "/dsd_main.png", year: "2nd Year", path: "/subject-DSDModules" },
  { name: "Multivariable Calculus and Differential Equations", image: "/cal_main(1).png", year: "1st Year", path: "/subject-CalculusModules" },
  { name: "Compiler Design", image: "/compiler_main.png", year: "3rd Year", path: "/subject-CDModules" },
  { name: "Artificial Intelligence", image: "/ai_main.png", year: "3rd Year", path: "/subject-AIModules" },
  { name: "OOPS", image: "/OOP_main.png", year: "1st Year", path: "/subject-OOPSModules" },
  { name: "Chemistry", image: "/chemistry_main.png", year: "1st Year", path: "/subject-ChemistryModules" },
  { name: "Basic Engineering", image: "/beee_main(1).png", year: "1st Year", path: "/subject-BEEEModules" },
  { name: "DAA", image: "/DAA2.png", year: "2nd Year", path: "/subject-DAAModules" },
  { name: "CAO", image: "/CAO1.jpg", year: "2nd Year", path: "/subject-CAOModules" },
  { name: "TOC", image: "/TOC3.png", year: "2nd Year", path: "/subject-TOCModules" },
  { name: "MPMC", image: "/Mpmc.jpg", year: "2nd Year", path: "/subject-MPMCModules" },


];

const CourseCard = ({ name, image, year, path }) => (
  <li>
    <div className="course-card">
      <figure className="card-banner img-holder" style={{ "--width": 370, "--height": 220 }}>
        <img src={image} width="370" height="220" loading="lazy" alt={name} className="img-cover" />
      </figure>
      <div className="card-content">
        <span className="badge">{year}</span>
        <h3 className="h3">{name}</h3>
        <Link to={path} className="btn has-before">
          <span className="span">Start Learning</span>
        </Link>
      </div>
    </div>
  </li>
);

const CoursesPage = () => {
  const [selectedYear, setSelectedYear] = useState("All");

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const filteredCourses = selectedYear === "All"
    ? allCourses
    : allCourses.filter(course => course.year === selectedYear);

  return (
    <>
      <section className="section course" id="courses" aria-label="course" style={{ paddingTop: '120px' }}>
        <div className="container">
          <p className="section-subtitle" style={{ color: 'black' }}>Choose Your Subject!</p>
          <h2 className="h2 section-title" style={{ color: 'black' }}>Pick a Subject and get started!</h2>

          <div className="filter-container">
            <select className="filter-select" value={selectedYear} onChange={handleYearChange}>
              <option value="All">All Years</option>
              <option value="1st Year">1st Year</option>
              <option value="2nd Year">2nd Year</option>
              <option value="3rd Year">3rd Year</option>
            </select>
          </div>

          <ul className="grid-list">
            {filteredCourses.map((course, index) => (
              <CourseCard key={index} {...course} />
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default CoursesPage;

